export default __webpack_public_path__ + "static/media/Collar of Vigor.3dea4f75.jpg";